import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import { css, StyleSheet } from 'aphrodite';
import { Paper, FontIcon, RadioButton } from 'material-ui';
import RaisedButton from '../../tc-ui/raised-button-with-loader';
import AddItemCard from '../../contracting/generic-components/add-item-card/AddItemCard';
import { countries, currencies } from '../../../utils/select-fields';
import Select from 'react-select';

const styles = StyleSheet.create({
  header: { backgroundColor: '#f5f5f5', padding: '0 16px', lineHeight: '48px', color: 'black', fontSize: '20px' },
  container: { padding: '0px 2px 4px 2px', marginBottom: '64px' },
  ruleBox: {
    padding: '24px 0',
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid #e0e0e0',
  },
  countryCurrencyBox: {
    minWidth: '185px',
    display: 'flex',
    flexDirection: 'column',
  },
  countryCurrencyBoxSelected: {
    minWidth: '185px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    bottom: '12px',
  },
  radioGroup: {
    padding: '0 4px',
  },
  country: {
    width: '250px',
  },
  currency: {
    width: '250px',
  },
  productType: {
    width: '200px',
  },
  codes: {
    border: '1px solid #e0e0e0',
    padding: '0 8px',
    width: '300px',
    fontSize: '12px',
    height: '32px',
    borderRadius: '3px',
  },
});
const IntegrationPriceCodesSettings = props => {
  const {
    priceCodesSetting,
    updateSettings,
    saveSettings,
    savingSettings,
    enablePriceCodeSettingSaveButton,
    triggerSnackBarMessage,
  } = props;
  const {
    defaultCode,
    rules,
  } = priceCodesSetting;
  const updatePCS = (payload, enableButton) => updateSettings({
    priceCodesSetting: {
      ...priceCodesSetting,
      ...payload,
    },
    enablePriceCodeSettingSaveButton: enableButton,
  });
  const addOne = () => updatePCS({
    rules: [...rules, { productType: 'all', codes: [] }],
  });
  const removeRule = i => () => updatePCS({
    rules: R.remove(i, 1, rules),
  }, true);
  const checkCountryOrCurrency = (index, val) => () => updatePCS({
    rules: R.update(
      index,
      { ...rules[index], countryOrCurrency: val },
      rules,
    ),
  });
  const selectCountry = index => ({ value }) => updatePCS({
    rules: R.update(
      index,
      { ...rules[index], country: value },
      rules,
    ),
  }, true);
  const selectCurrency = index => ({ value }) => updatePCS({
    rules: R.update(
      index,
      { ...rules[index], currency: value },
      rules,
    ),
  }, true);
  const selectProductType = index => ({ value }) => updatePCS({
    rules: R.update(
      index,
      { ...rules[index], productType: value },
      rules,
    ),
  }, true);
  const updateRulePriceCodes = index => ({ target: { value } }) => updatePCS({
    rules: R.update(
      index,
      { ...rules[index], codes: value.split(',') },
      rules,
    ),
  }, true);
  const updateDefault = ({ target: { value } }) => updatePCS({
    defaultCode: value,
  }, true);
  const validRules = rules.filter(rule => rule.codes.length
    && (
      (rule.countryOrCurrency === 'country' && rule.country)
    || rule.countryOrCurrency === 'currency' && rule.currency)
  );
  const save = () => {
    saveSettings({
      priceCodesSetting: {
        ...priceCodesSetting,
        defaultCode,
        rules: validRules,
      },
    }, { enablePriceCodeSettingSaveButton: false })
      .catch(() => {
        triggerSnackBarMessage('Unable to save price code settings.');
        updateSettings({ savingPriceCodeSettingsError: true, enablePriceCodeSettingSaveButton: true });
      });
  };
  return (
    <div>
      <div style={{ marginBottom: '12px' }}>
        <FontIcon className="tc-icon-bulb" color="#ffc800" style={{ fontSize: '24px' }} />
        <div style={{ display: 'inline-block', width: '90%', marginLeft: '2%' }}>
          You can configure the price code(s) that your rates will be exported with by adding a setting here. Tip: use commas to separate price codes.
        </div>
      </div>
      <div className={css(styles.container)}>
        <Paper style={{ marginTop: '24px', minHeight: '100px' }}>
          <div className={css(styles.header)}>Price Codes Setting</div>
          <br/>
          <div style={{ marginLeft: '16px' }}>
            {
              rules.map((rule, i) => (
                <div className={css(styles.ruleBox)} key={i}>
                  <b>Rule {i + 1}:</b>&nbsp;
                  Export rates in&nbsp;
                  <div className={css(rule.countryOrCurrency ? styles.countryCurrencyBoxSelected : styles.countryCurrencyBox)}>
                    <div className={`flex-tc-sb ${css(styles.radioGroup)}`}>
                      <RadioButton
                        label="Country"
                        iconStyle={{ marginRight: '4px' }}
                        checked={rule.countryOrCurrency === 'country'}
                        onCheck={checkCountryOrCurrency(i, 'country')}
                      />
                      <RadioButton
                        label="Currency"
                        iconStyle={{ marginRight: '4px' }}
                        checked={rule.countryOrCurrency === 'currency'}
                        onCheck={checkCountryOrCurrency(i, 'currency')}
                      />
                    </div>
                    {
                      rule.countryOrCurrency === 'country' && (
                        <div className={css(styles.country)}>
                          <Select
                            name="countriesServed"
                            scrollMenuIntoView={false}
                            options={countries}
                            clearable={false}
                            placeholder="Please search and select a country..."
                            value={rule.country}
                            onChange={selectCountry(i)}
                          />
                        </div>
                      )
                    }
                    {
                      rule.countryOrCurrency === 'currency' && (
                        <div className={css(styles.currency)}>
                          <Select
                            name="currency"
                            scrollMenuIntoView={false}
                            options={currencies}
                            clearable={false}
                            placeholder="Please search and select a currency..."
                            value={rule.currency}
                            onChange={selectCurrency(i)}
                          />
                        </div>
                      )
                    }
                  </div>
                  &nbsp;for&nbsp;
                  <div className={css(styles.productType)}>
                    <Select
                      name="productType"
                      scrollMenuIntoView={false}
                      options={[
                        { value: 'all', label: 'all' },
                        { value: 'accom', label: 'accommodation' },
                        { value: 'non-accom', label: 'non-accommodation' },
                      ]}
                      clearable={false}
                      value={rule.productType}
                      onChange={selectProductType(i)}
                    />
                  </div>
                  &nbsp;services to&nbsp;
                  <input
                    value={rule.codes.join(',')}
                    placeholder="Enter price codes here..."
                    onChange={updateRulePriceCodes(i)}
                    className={css(styles.codes)}
                  />.&nbsp;&nbsp;
                  <RaisedButton
                    label="Remove Rule"
                    primary
                    style={{ marginLeft: '12px', width: '130px' }}
                    onTouchTap={removeRule(i)}
                  />
                </div>
              ))
            }
            {
              Boolean(rules.length) && <br/>
            }
            <AddItemCard
              onClick={addOne}
              color="#00bcd4"
              text="Add price code setting"
            />
            <br/>
            <br/>
            Please enter a default price code (optional): &nbsp;
            <input
              value={defaultCode}
              onChange={updateDefault}
              style={{ width: '15%', textAlign: 'right', fontSize: '25px', position: 'relative', top: '6px', height: '32px', marginLeft: '2%' }}
            />
          </div>
          <RaisedButton
            label={enablePriceCodeSettingSaveButton ? 'Save' : 'Saved'}
            secondary
            loader={savingSettings}
            disabled={!enablePriceCodeSettingSaveButton}
            style={{ margin: '12px 80%', width: '130px' }}
            onTouchTap={save}
          />
        </Paper>
      </div>
    </div>
  );
};

const mapPropsToState = ({ integration }) => ({
  savingPriceCodeSettingsError: integration.getIn(['settings', 'savingPriceCodeSettingsError']),
  savingSettings: integration.getIn(['settings', 'savingSettings']),
  enablePriceCodeSettingSaveButton: integration.getIn(['settings', 'enablePriceCodeSettingSaveButton']),
  priceCodesSetting: integration.getIn(['settings', 'priceCodesSetting']) ? integration.getIn(['settings', 'priceCodesSetting']).toJS() : {},
});

export default connect(mapPropsToState)(IntegrationPriceCodesSettings);



// WEBPACK FOOTER //
// ./src/app/components/integration/settings/price-codes.jsx